import { logger } from '@/lib/logger';

export function measure<T>(label: string, fn: () => T): T {
  const start = performance.now();
  const result = fn();
  const elapsed = performance.now() - start;
  if (elapsed > 16) {
    logger.warn(`[Perf] ${label} took ${elapsed.toFixed(1)}ms (exceeds frame budget)`);
  } else {
    logger.debug(`[Perf] ${label}: ${elapsed.toFixed(1)}ms`);
  }
  return result;
}

export async function measureAsync<T>(label: string, fn: () => Promise<T>): Promise<T> {
  const start = performance.now();
  try {
    const result = await fn();
    const elapsed = performance.now() - start;
    if (elapsed > 1000) {
      logger.warn(`[Perf] ${label} took ${elapsed.toFixed(0)}ms`);
    } else {
      logger.debug(`[Perf] ${label}: ${elapsed.toFixed(0)}ms`);
    }
    return result;
  } catch (error) {
    const elapsed = performance.now() - start;
    logger.warn(`[Perf] ${label} failed after ${elapsed.toFixed(0)}ms`);
    throw error;
  }
}

let longTaskCount = 0;

export function initPerformanceObserver(): void {
  if (typeof PerformanceObserver === 'undefined') return;

  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        longTaskCount++;
        logger.warn(
          `[Perf] Long task detected: ${entry.duration.toFixed(0)}ms (total: ${longTaskCount})`,
        );
      }
    });
    observer.observe({ type: 'longtask', buffered: true });
  } catch {
    // longtask observer not supported in all browsers
  }
}

export function getLongTaskCount(): number {
  return longTaskCount;
}
